import React from 'react';
import PropTypes from 'prop-types';

const VerticalDivider = ({ children }) => {
  return (
    <div className="flex items-center">
      {children.map((child, i) => (
        <React.Fragment key={i}>
          {i % 2 !== 0 && <div className="w-px h-4 bg-gray-200 mx-4 h-6" />}
          {child}
        </React.Fragment>
      ))}
    </div>
  );
};

VerticalDivider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default VerticalDivider;
